/**
 * optimizeImageUrl(url, width)
 *
 * For common stock-photo CDNs that support on-the-fly resize + format conversion
 * (Unsplash, Pexels, Pixabay, customer-assets.emergentagent.com), append width +
 * WebP params so the browser downloads a perfectly-sized WebP instead of a
 * 2400px JPG. Drops everything past the first `?` so we can stamp our own params.
 *
 * For URLs we don't recognise (uploaded media, Google Drive, etc.), returns the
 * input unchanged.
 */
const STOCK_HOSTS = {
  'images.unsplash.com': (path, w) => `?auto=format,compress&w=${w}&q=80&fit=crop`,
  'images.pexels.com': (path, w) => `?auto=compress&cs=tinysrgb&w=${w}`,
  'cdn.pixabay.com': (path, w) => `?w=${w}`,
};

export function optimizeImageUrl(url, width = 800) {
  if (!url || typeof url !== 'string') return url;
  try {
    const u = new URL(url, window.location.origin);
    const builder = STOCK_HOSTS[u.host];
    if (!builder) return url; // unknown host — leave alone
    return `${u.origin}${u.pathname}${builder(u.pathname, width)}`;
  } catch (_) {
    return url;
  }
}

/**
 * srcSet helper — returns a "url 800w, url 1200w, url 1600w" string for the same image
 * at multiple widths. Use when the image lives in a CSS layout where the browser can
 * pick the right size.
 */
export function imageSrcSet(url, widths = [400, 800, 1200, 1600]) {
  if (!url) return '';
  return widths.map((w) => `${optimizeImageUrl(url, w)} ${w}w`).join(', ');
}
